import { types, getParent } from 'mobx-state-tree';
import Item from './Item';
import PricingStrategy from './PricingStrategy';
import { Statistics } from './Statistics';

const Discovery = types
  .model('Discovery', {
    // from response
    accountCode: types.optional(types.string, ''),
    discoveryItems: types.optional(types.array(Item), []),
    discoveryItemsBeforeOptimize: types.optional(types.array(Item), []),
    finishDatetime: types.maybe(types.string),
    id: types.maybe(types.number),
    includesVariants: types.optional(types.boolean, false),
    isActive: types.optional(types.boolean, false),
    itemsCount: types.optional(types.number, 0),
    itemsDiscovered: types.optional(types.number, 0),
    itemsFailed: types.optional(types.number, 0),
    listings: types.maybe(types.array(types.frozen)),
    pricingStrategy: types.optional(PricingStrategy, {}),
    sourceMarketplaceId: types.optional(types.string, ''),
    startDatetime: types.optional(types.string, ''),
    statusId: types.optional(types.number, 0),
    // waiting for backend
    statistics: types.maybe(Statistics, {}),
    // additional
    isMainSelected: false,
    rowsSelected: types.optional(types.array(types.number), []),
    variationsSelected: types.optional(types.map(types.array(types.number)), {}),
    listServerErrors: types.frozen,
    listStatus: '',
    // errorMessage: types.maybe(types.string),
  })
  .views(self => ({
    get showToast() {
      return getParent(self, 2).showToast;
    },
    get enums() {
      return getParent(self, 2).enums;
    },
  }))
  .actions(self => ({
    initDiscovery: () => {
      self.discoveryItems = [];
    },
    /* eslint-disable */
    toggleVariationSelectionInternal: (mainId, variationId, toggleBool) => {
      const currentMainItem = self.variationsSelected.get(mainId);
      if (toggleBool) {
        if (!self.rowsSelected.some(id => id === mainId)) {
          self.rowsSelected.push(mainId);
        }
        if (currentMainItem) {
          self.variationsSelected.get(mainId).push(variationId);
        } else {
          self.variationsSelected.set(mainId, []);
          self.variationsSelected.get(mainId).push(variationId);
        }
      } else {
        const filtered = self.variationsSelected.get(mainId).filter(id => id !== variationId);
        self.variationsSelected.delete(mainId);
        self.variationsSelected.set(mainId, filtered);
        if (!self.variationsSelected.get(mainId).length) {
          self.variationsSelected.delete(mainId);
        }
      }
    },
    toggleSelectAll: () => {
      if (self.isMainSelected) {
        self.rowsSelected = [];
        self.variationsSelected.clear();
      } else {
        self.rowsSelected = [];
        self.discoveryItems.forEach(item => {
          self.rowsSelected.push(item.id);
          self.variationsSelected.set(item.id, []);
          const current = self.variationsSelected.get(item.id);
          item.variations.forEach(variation => current.push(variation.id));
        });
      }
      self.isMainSelected = !self.isMainSelected;
    },
    toggleSelectRow: (e, id) => {
      if (e.target['data-variation']) {
        const mainId = Number(e.target['data-variation'].split('_')[0]);
        const variationId = Number(e.target['data-variation'].split('_')[1]);
        self.toggleVariationSelectionInternal(mainId, variationId, e.target.checked);
      } else {
        if (e.target.checked) {
          self.rowsSelected.push(id);
          self.isMainSelected = true;
          const variations = self.discoveryItems
            .find(item => item.id === id)
            .variations.map(item => item.id);
          self.variationsSelected.set(id, variations);
        } else {
          self.rowsSelected = self.rowsSelected.filter(item => item !== id);
          self.isMainSelected = self.rowsSelected.length > 0;
          self.variationsSelected.delete(id);
        }
      }
    },
    /* eslint-enable */
    setProfitType: type => {
      self.pricingStrategy.setProfitType(type);
    },
    setIncludesVariants: val => {
      self.includesVariants = val;
    },
    setDiscoveryItemsBeforeOptimization: discoveryItems => {
      self.discoveryItemsBeforeOptimization = discoveryItems;
    },
  }));

export default Discovery;
